import { Injectable } from "@angular/core";
import { ChartsHandlerService } from "../handlers/charts-handler.service";

@Injectable({
  providedIn: "root",
})
export class ChartsService {
  constructor(private ChartsHandlerService: ChartsHandlerService) {}

  getHeatMap(masterAccountID: number, chartsObj: any) {
    return this.ChartsHandlerService.postChart(masterAccountID, chartsObj);
  }
}
